import debounce from 'lodash/debounce';

import { NO_RETRY } from 'src/modules/error-helper';

import { addFailedAction } from './actionCreators';
import { extractActionMeta } from './extractActionMeta';

const defaultClassifyError = () => NO_RETRY;

const DEBOUNCE_TIME = 100;

const createUpdateHook =
  (
    {
      run,
      success,
      failure,
      classifyError = defaultClassifyError,
      retryCount = 2,
    },
    getUpdater,
  ) =>
  (store, action) => {
    const { id, parent } = extractActionMeta(action);
    const updater = getUpdater(parent, id, {
      classifyError,
      retryCount,
    });
    const update = updater(run, action.payload, store);

    if (update !== null && success && failure) {
      return update
        .then((v) => store.dispatch(success(v, action.payload)))
        .catch((e) => {
          if (classifyError(e) !== NO_RETRY) {
            store.dispatch(addFailedAction(parent, id, action));
          }

          return store.dispatch(failure(e, action.payload, store));
        });
    }

    return null;
  };

export const createUpdater = (props, getUpdater) => {
  const { on, debounceTime = DEBOUNCE_TIME } = props;

  return {
    actionType: on,
    updater: debounce(createUpdateHook(props, getUpdater), debounceTime, {
      leading: true,
    }),
  };
};
